/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Share_ChipInputs */

const en_start_page_share_chip = /** @type {(inputs: Start_Page_Share_ChipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link in bio`)
};

const pl_start_page_share_chip = /** @type {(inputs: Start_Page_Share_ChipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link w bio`)
};

/**
* | output |
* | --- |
* | "Link in bio" |
*
* @param {Start_Page_Share_ChipInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_share_chip = /** @type {((inputs?: Start_Page_Share_ChipInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Share_ChipInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_share_chip(inputs)
	return en_start_page_share_chip(inputs)
});